import PropTypes from 'prop-types'
import React from 'react'
import {
  Typography, Box, Container, useMediaQuery, useTheme,
} from '@material-ui/core'
import LinearProgress from '@material-ui/core/LinearProgress'
import CardEvent from '@components/card-event/card-event'
import PaginationNew from '@components/pagination-new'
import usePagination from '@components/upcoming-featured-events/usePagination'
import Button from '@material-ui/core/Button'
import useStyles from './upcoming-featured-events.styles'

const UpcomingFeaturedEvents = (props) => {
  const {
    sys,
  } = props

  const styles = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const limit = isMobile ? 4 : 8

  const {
    data, loading, handlePagination, skip,
  } = usePagination(isMobile, limit, sys.id)

  const noResults = !loading && !!data && data.eventCollection?.total === 0
  return (
    <Box className={styles.root}>
      <Container>
        <Box pt={2} pb={9}>
          <Typography
            variant="h4"
            variantMapping={{ h4: 'h2' }}
            className={styles.headline}
          >Upcoming Events
          </Typography>
          <Box mb={5}>
            {loading && (<LinearProgress color="secondary" />)}
          </Box>
          {data?.eventCollection.items.length > 0 && (
            <Box className={styles.eventsWrapper}>
              {data.eventCollection.items.map(item => (
                <CardEvent
                  key={item.sys.id}
                  showEventCollection={false}
                  {...item}
                />
              ))}
            </Box>
          )}
          {noResults && <Typography variant="body1" className={styles.zeroState}>There are no upcoming events.</Typography>}
          {isMobile ? (
          data?.eventCollection?.items.length !== data?.eventCollection.total && (
              <Box className={styles.mobileLoadMore} my={5}>
                <Button disabled={loading} onClick={() => handlePagination()} aria-label="Load More Events" variant="contained" color="primary">Load More</Button>
              </Box>
            )
          ) : (
        data?.eventCollection && data?.eventCollection.total > limit && (
              <PaginationNew
                limit={limit}
                offset={skip}
                total={data.eventCollection.total}
                onClick={(e, newOffset) => handlePagination(newOffset)}
              />
            )
          )}
        </Box>
      </Container>
    </Box>
  )
}

UpcomingFeaturedEvents.propTypes = {
  sys: PropTypes.shape({ id: PropTypes.string }),
}

UpcomingFeaturedEvents.defaultProps = {
}

export default UpcomingFeaturedEvents
